/**
 * Возвращает hash код строки
 * @param {string | Object} strOrObject - строка или объекта, для которой вычисляется hash код
 */
export function getHashCode(strOrObject: string | object) {
  let hash = 0
  const str = typeof strOrObject === 'string' ? strOrObject : JSON.stringify(strOrObject)

  if (str.length === 0) {
    return hash
  }

  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i)
    hash = (hash << 5) - hash + char
    hash = hash & hash
  }

  return hash
}
